import { stringValue } from 'vega-util';
import { FACET_CHANNELS } from '../../channel';
import { SELECTION_ID } from '../../selection';
import { accessPathWithDatum } from '../../util';
import { isFacetModel } from '../model';
import interval from './interval';
import multi from './multi';
import single from './single';
export var STORE = '_store';
export var TUPLE = '_tuple';
export var MODIFY = '_modify';
export var SELECTION_DOMAIN = '_selection_domain_';
export var VL_SELECTION_RESOLVE = 'vlSelectionResolve';
var compilers = {
  single: single,
  multi: multi,
  interval: interval
};
export function forEachSelection(model, cb) {
  var selections = model.component.selection;

  for (var name in selections) {
    if (selections.hasOwnProperty(name)) {
      var sel = selections[name];
      cb(sel, compilers[sel.type]);
    }
  }
}

function getFacetModel(model) {
  var parent = model.parent;

  while (parent) {
    if (isFacetModel(parent)) {
      break;
    }

    parent = parent.parent;
  }

  return parent;
}

export function unitName(model) {
  var name = stringValue(model.name);
  var facetModel = getFacetModel(model);

  if (facetModel) {
    var facet = facetModel.facet;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = FACET_CHANNELS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var channel = _step.value;

        if (facet[channel]) {
          name += " + '__facet_".concat(channel, "_' + (").concat(accessPathWithDatum(facetModel.vgField(channel), 'facet'), ")");
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return name;
}
export function requiresSelectionId(model) {
  var identifier = false;
  forEachSelection(model, function (selCmpt) {
    identifier = identifier || selCmpt.project.some(function (proj) {
      return proj.field === SELECTION_ID;
    });
  });
  return identifier;
}
export function isRawSelectionDomain(domainRaw) {
  return domainRaw.signal.indexOf(SELECTION_DOMAIN) >= 0;
}